module.exports = __webpack_public_path__ + "img/flower_leaf_37.a8ef6f94.png";